import { useState } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { useGenerateResetPasswordTokenMutation } from "generated/graphql";
import AuthHeader from "components/auth/AuthHeader";
import InputField from "components/auth/InputField";
import { AuthFormWrapper, Error } from "components/auth/shared";

const RegistrationForm = styled.form``;

function RegistrationPage() {
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"pending" | "complete">("pending");

  const [generateResetPasswordTokenMutation, { loading }] =
    useGenerateResetPasswordTokenMutation();

  const handleSubmit = () => {
    if (email !== "") {
      generateResetPasswordTokenMutation({
        variables: {
          input: {
            email
          },
        },
        onError(error) {
          setErrMsg(error.message);
        },
        onCompleted() {
          setState("complete");
          setEmail("");
        }
      })
        .catch((err) => setErrMsg(err.message))
        .finally(() => {
          setState("complete");
          setEmail("");
        });
    }
  };

  return (
    <>
      <AuthHeader />
      <AuthFormWrapper>
        <h1>Reset Password</h1>
        <p>
          Remember your password? <Link to="/auth/login">Log In</Link>
        </p>
        {errMsg && <Error>{errMsg}</Error>}
        {state === "complete" && (
          <Error>
            Please check your email to for reset instructions
          </Error>
        )}
        {state === "pending" && (
          <RegistrationForm
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <InputField
              setValue={setEmail}
              value={email}
              placeholder="name@email.com"
              type="email"
              name="email"
              label="Email"
              className="input-box"
            />
            <button type="submit" className="btn" disabled={loading}>
              Reset password
            </button>
            <br />
          </RegistrationForm>
        )}
      </AuthFormWrapper>
    </>
  );
}

export default RegistrationPage;
